exports.list = {
    path: '/laporan_hutang_dagang',
    name: 'laporan_hutang_dagang', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_hutang_dagang/List.vue"),
  }
  